/* istanbul ignore file */
/* tslint:disable */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { PlagiarismCase, PlagiarismRun } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function plagiarism(config) {
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(PlagiarismRun)),
    });
    const getCasesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(PlagiarismCase))),
    });
    return Object.freeze({
        /**
         * Delete a given plagiarism run and all its cases.
         *
         * This is irreversible, so make sure the user really wants this!
         *
         * @param arg The arguments to the function.
         * @param arg.plagiarismId The id of the run to delete.
         * @returns Nothing.
         */
        delete: async ({ plagiarismId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/plagiarism/${plagiarismId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Get a `.models.PlagiarismRun`.
         *
         * @param arg The arguments to the function.
         * @param arg.plagiarismId The of the plagiarism run.
         * @returns An single plagiarism run.
         */
        get: async ({ plagiarismId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/plagiarism/${plagiarismId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Get all the `.models.PlagiarismCase`s for the given `.models.PlagiarismRun`.
         *
         * @param arg The arguments to the function.
         * @param arg.plagiarismId The of the plagiarism run.
         * @param arg.offset The amount of cases that should be skipped, only used when limit is given. Defaults to 0.
         * @param arg.limit The amount of cases to get. Defaults to infinity.
         * @returns An array of JSON serialized plagiarism cases.
         */
        getCases: async ({ plagiarismId, offset = undefined, limit = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/plagiarism/${plagiarismId}/cases/`, getCasesResponse.v, undefined, {
                offset,
                limit,
            });
            return result;
        },
    });
}
